import * as React from 'react';

function PricingPage() {
  // Paste the stripe-pricing-table snippet in your React component
 

  return (
    
    <stripe-pricing-table pricing-table-id="prctbl_1N39tyDZyeGy77qOGDjjlvzq"
    publishable-key="pk_test_51MzKBlDZyeGy77qOHeOQykNEE2WtM7I4IRzUdHlSiizWWdj12LqZ9GzdmaZDXdPtiBjkSuG1WoLKqobB84799i7j00VczhO1QN">
    </stripe-pricing-table>
    
  );
}

export default PricingPage;
